import device from "current-device";
import { pURLs } from "../../utils/parameters";
import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  browserVersion,
  osName,
  osVersion,
  engineName,
  engineVersion,
  deviceType,
  mobileVendor,
} from 'react-device-detect';



/* https://github.com/matthewhudson/current-device */
export function getDevice() {
  return device();
}

/* True if the device is a phone or a tablet */
export function phoneDetected() {
  return device.mobile() ? true : false;
}

/* True if desktop is detected */
export function desktopDetected() {
  return device.desktop() || device.windows() ? true : false;
}

/* Returns "mobile", "desktop", "tablet" or "unknown" */
export function getDeviceType() {
  // console.log(device.type);
  return device.type;
}

/* Redirect to google play */
export function redirectToGooglePlay() {
  if (phoneDetected()) {
    openNewPage(pURLs.app);
  }
}

/* Browser name */
export function getBrowser() {
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) !== -1) {
    return "Opera";
  } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    return "Chrome";
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    return "Safari";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    return "Firefox";
  } else if (navigator.userAgent.indexOf("MSIE") !== -1 || !!document.documentMode === true) {
    //IF IE > 10
    return "IE";
  } else {
    return "Unknown";
  }
}

/* Push new page */
export function openNewPage(route) {
  window.location.href = route;
}





export const getReportDevice = async () => {
  // Información sobre la webcam
  const getWebcamInfo = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.filter(device => device.kind === 'videoinput');
    } catch (error) {
      console.error('Error al obtener información de la webcam:', error);
      return [];
    }
  };

  // Información sobre la red
  const getNetworkInfo = () => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      return {
        downlink: connection.downlink,
        effectiveType: connection.effectiveType,
        rtt: connection.rtt,
        saveData: connection.saveData,
      };
    }
    return {};
  };

  const webcamData = await getWebcamInfo();
  const networkData = getNetworkInfo();

  const info = {
    isMobile,
    isTablet,
    isDesktop,
    browserName,
    browserVersion,
    osName,
    osVersion,
    engineName,
    engineVersion,
    deviceType,
    mobileVendor,
    webcamInfo: webcamData,
    networkInfo: networkData,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    deviceMemory: navigator.deviceMemory || 'N/A',
    hardwareConcurrency: navigator.hardwareConcurrency,
  };

  console.log("🚀 ~ getReportDevice ~ info:", info)
  console.log(info);
  return info;
};
  

